import {Modal, Button, Typography, Space} from 'antd';
import React from 'react';

import letsIconsFormLights from '../../assets/letsIconsFormLight.png';

const {Title, Paragraph} = Typography;

interface OnboardingFormModalProps {
  open: boolean;
  onFillForm: () => void;
  onCancel: () => void;
}

const OnboardingFormModal: React.FC<OnboardingFormModalProps> = ({
  open,
  onFillForm,
  onCancel
}) => {
  return (
    <Modal
      open={open}
      title={null}
      footer={null}
      onCancel={onCancel}
      closeIcon={null}
      centered
      width={580}
      bodyStyle={{padding: '25px 15px'}}
      zIndex={10000}
    >
      <Space
        direction="vertical"
        align="center"
        size={28}
        style={{width: '100%'}}
      >
        {/* Icon */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img src={letsIconsFormLights} />
        </div>

        {/* Title */}
        <Title level={3} style={{margin: 0, color: '#1a3e3d', fontWeight: 600}}>
          Onboarding Form
        </Title>

        {/* Description */}
        <Paragraph
          style={{
            textAlign: 'center',
            fontSize: 16,
            color: '#595959',
            marginBottom: 8
          }}
        >
          Please complete your onboarding process by filling out your onboarding
          form.
        </Paragraph>

        {/* Action Buttons */}
        <Space size={16}>
          <Button type="primary" size="large" onClick={onFillForm}>
            Click to fill
          </Button>
        </Space>
      </Space>
    </Modal>
  );
};

export default OnboardingFormModal;
